module.exports = __webpack_public_path__ + "h5/img/hot_title.2f9a5771.png";